import find from 'lodash/find';
import moment from 'moment';
import { createSelector } from 'reselect';
import Passport from '@mos-front-components/public/es/components/Passport';
import { getUserBirthdateSelector } from '../mainDataChild/selectors';
import validator from '../../helpers/validator';
import {
  DOCUMENT_TITLES,
  MAPPED_DOCUMENTS
} from '../passport/permittedDocuments';
import { API_DATE_FORMAT, DATE_FORMAT } from '../../helpers/date';

const { FIELD_NAME, DOCUMENT_TYPE } = Passport;

export const passportSelector = state => state.passportChild;

export const passportValuesSelector = createSelector(
  passportSelector,
  subState => ({ ...subState.data })
);

export const documentsSelector = createSelector(
  passportSelector,
  subState => subState.documents
);

export const passportBlurSelector = createSelector(
  passportSelector,
  subState => subState.blur
);

export const passportValidationSelector = createSelector(
  passportValuesSelector,
  getUserBirthdateSelector,
  (subState, birthdate) =>
    validator({ ...subState, birthdate }, subState.documentType)
);

export const passportDocumentTypeSelector = createSelector(
  passportValuesSelector,
  subState => subState.documentType
);

export const passportErrorsSelector = createSelector(
  passportValidationSelector,
  subState => subState.errors
);

export const passportEditableFieldsSelector = createSelector(
  passportSelector,
  subState => subState.editableFields
);

/*
 * дисейбл паспорта если с сервера пришел паспорт РФ и хотя бы одно поле в нем с данными
 */
export const passportDisabledSelector = createSelector(
  passportSelector,
  subState => subState.disabled
);

export const getDocumentFromTypeSelector = documentType =>
  createSelector(documentsSelector, subState => {
    const emptyDocument = {
      documentType,
      [FIELD_NAME.number]: '',
      [FIELD_NAME.dateOfIssue]: '',
      [FIELD_NAME.byWhom]: ''
    };

    return find(subState, { documentType }) || emptyDocument;
  });

export const submitDocCodeSelector = createSelector(
  passportValuesSelector,
  ({ documentType }) =>
    MAPPED_DOCUMENTS[documentType || DOCUMENT_TYPE.PASSPORT_RF]
);

export const submitIdDocTypeSelector = createSelector(
  passportValuesSelector,
  ({ documentType }) =>
    DOCUMENT_TITLES[documentType || DOCUMENT_TYPE.PASSPORT_RF]
);

export const documentNumberPartsSelector = createSelector(
  passportValuesSelector,
  submitDocCodeSelector,
  (personState, docCode) => {
    if (docCode === DOCUMENT_TYPE.PASSPORT_RF) {
      return {
        doc_serie: personState[FIELD_NAME.number]
          ? personState[FIELD_NAME.number].substring(0, 4)
          : '',
        doc_number: personState[FIELD_NAME.number]
          ? personState[FIELD_NAME.number].substring(4, 10)
          : ''
      };
    }

    return {
      doc_number: personState[FIELD_NAME.number]
        ? personState[FIELD_NAME.number].replace(/\s+/gi, '')
        : ''
    };
  }
);

export const appealSubmitIdentityDocumentSelector = createSelector(
  passportValuesSelector,
  submitDocCodeSelector,
  submitIdDocTypeSelector,
  documentNumberPartsSelector,
  (personState, docCode, idDocType, documentParts) => {
    const docDate = moment(
      personState[FIELD_NAME.dateOfIssue],
      DATE_FORMAT
    ).clone();
    return {
      doc_code: docCode.toUpperCase(),
      doc_title: idDocType,
      doc_date: docDate && docDate.format(API_DATE_FORMAT),
      who_sign: personState[FIELD_NAME.byWhom],
      ...documentParts
    };
  }
);
